module.exports = __webpack_public_path__ + "static/images/map/markers/pin_AB810A.svg";